import React from "react";
import { Menu, message } from "antd";
import styles from "./SocialShare.module.css";
import publicPageData from '../../Utils/publicPageData.json';
import {
  CopyOutlined,
} from "@ant-design/icons";
import {
  FacebookShareButton,
  FacebookIcon,
  TelegramShareButton,
  TelegramIcon,
  LinkedinShareButton,
  LinkedinIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";
import { useSelector } from "react-redux";

type Props = {
};

const {socialShareData} = publicPageData;

const SocialShare = (props: Props) => {
  
  const {collectionUrl, authorName, title}:any = useSelector((state:any)=> state.modalData.data);

  const handleCopy=()=>{
  navigator.clipboard.writeText(collectionUrl);
  message.success('Copied', 1);
}

  const items = [
    { key: "copy", icon: <CopyOutlined onClick={handleCopy} className={styles.bottomBarIcons} />,  },
    {
      key: "whatsapp",
      icon: (
        <WhatsappShareButton
          url={collectionUrl}
          title={`Checkout this amazing collection - *${title}* by _${authorName}_ on NotableHQ.\nHere's the link : `}
        >
          <WhatsappIcon size={25} round />
        </WhatsappShareButton>
      ),
      style: { display: 'flex' }
    },
    {
      key: "linkedin",
      icon: (
        <LinkedinShareButton
          url={collectionUrl}
          title={`Checkout this amazing collection - ${title} by ${authorName} on NotableHQ.\nHere's the link : `}
          summary={socialShareData?.description}
          source={socialShareData?.source}
        >
          <LinkedinIcon size={25} round />
        </LinkedinShareButton>
      ),
      style: { display: 'flex' }
    },
    {
      key: "telegram",
      icon: (
        <TelegramShareButton
          url={collectionUrl}
          title={`Checkout this amazing collection - ${title} by ${authorName} on NotableHQ.\nHere's the link : `}
        >
          <TelegramIcon size={25} round />
        </TelegramShareButton>
      ),
      style: { display: 'flex' }
    },
    {
      key: "facebook",
      icon: (
        <FacebookShareButton
          url={collectionUrl}
          hashtag="#notablehq"
        >
          <FacebookIcon size={25} round />
        </FacebookShareButton>
      ),
      style: { display: 'flex' }
    },
  ];
  

  return (
    <>
      <Menu
        className={styles.bottomBarContainer}
        overflowedIndicatorPopupClassName={styles.popup}
        theme="light"
        mode="horizontal"
        defaultSelectedKeys={["2"]}
        items={items}
      />
    </>
  );
};

export default SocialShare;
